import initials from 'initialism';

export default {
	initials: name => initials(name, 3)
};
